export default __webpack_public_path__ + "static/media/wShoes_1_p2.a173c7a1.jpeg";